export function LoadingBlock() {
    return <div className="LoadingBlock" />;
}